import React from "react";
import "./TransferMoneyModel.css";
import Button from "../Button/Button";

const TransferMoneyModal = ({
  onClick,
  processing,
  transfer,
  withdraw,
  header,
  setModal,
  error,
  verifyBank,
  setVerifyBank,
  bankLinkStep = "link",
  description,
  setDescription,
  email,
  setEmail,
  routingNumber,
  setRoutingNumber,
  accountNumber,
  setAccountNumber,
  microAmount1,
  setMicroAmount1,
  microAmount2,
  setMicroAmount2,
  amount,
  setAmount,
}) => {
  const isMicrodepositStep = verifyBank && bankLinkStep === "verify";

  const closeModal = () => {
    setModal(false);
    setVerifyBank(false);
  };

  const subtitle = isMicrodepositStep
    ? "Check your bank statement for two small deposits and enter the amounts in cents."
    : verifyBank
      ? "Enter your US bank routing and account numbers to link payouts and withdrawals."
      : transfer
        ? "Add funds to your cash balance."
        : withdraw
          ? "Move money from your account to your linked bank."
          : "Send money to another Vaultline user by email.";

  return (
    <>
      <div
        className="transfer-modal-overlay"
        onClick={closeModal}
        aria-hidden="true"
      />

      <div
        className="transfer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="transfer-modal-title"
      >
        <div className="transfer-modal__header">
          <div>
            <h2 id="transfer-modal-title">{header}</h2>
            <p className="transfer-modal__subtitle">{subtitle}</p>
          </div>
          <button
            type="button"
            className="transfer-modal__close"
            onClick={closeModal}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="transfer-modal__body">
          {verifyBank && !isMicrodepositStep && (
            <div className="transfer-modal__grid transfer-modal__grid--bank">
              <div className="transfer-modal__field">
                <label htmlFor="routingNumber">Routing number</label>
                <input
                  id="routingNumber"
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="110000000"
                  value={routingNumber}
                  onChange={(e) => setRoutingNumber(e.target.value)}
                  required
                />
              </div>
              <div className="transfer-modal__field">
                <label htmlFor="accountNumber">Account number</label>
                <input
                  id="accountNumber"
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  placeholder="000123456789"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                  required
                />
              </div>
            </div>
          )}

          {isMicrodepositStep && (
            <div className="transfer-modal__grid transfer-modal__grid--bank">
              <div className="transfer-modal__field">
                <label htmlFor="microAmount1">Deposit 1 (cents)</label>
                <input
                  id="microAmount1"
                  type="number"
                  inputMode="numeric"
                  min="1"
                  max="99"
                  autoComplete="off"
                  placeholder="32"
                  value={microAmount1}
                  onChange={(e) => setMicroAmount1(e.target.value)}
                  required
                />
              </div>
              <div className="transfer-modal__field">
                <label htmlFor="microAmount2">Deposit 2 (cents)</label>
                <input
                  id="microAmount2"
                  type="number"
                  inputMode="numeric"
                  min="1"
                  max="99"
                  autoComplete="off"
                  placeholder="45"
                  value={microAmount2}
                  onChange={(e) => setMicroAmount2(e.target.value)}
                  required
                />
              </div>
            </div>
          )}

          {!transfer && !verifyBank && !withdraw && (
            <div className="transfer-modal__field transfer-modal__field--full">
              <label htmlFor="transferEmail">Recipient email</label>
              <input
                id="transferEmail"
                type="email"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          )}

          {!verifyBank && (
            <div className="transfer-modal__grid">
              <div className="transfer-modal__field transfer-modal__field--full">
                <label htmlFor="transferDescription">Description</label>
                <input
                  id="transferDescription"
                  type="text"
                  placeholder="Payment note"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
              <div className="transfer-modal__field">
                <label htmlFor="transferAmount">Amount (USD)</label>
                <input
                  id="transferAmount"
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>
            </div>
          )}
        </div>

        {error && <div className="transfer-modal__error-wrap">{error}</div>}

        <div className="transfer-modal__actions">
          <Button
            btnName="Cancel"
            onClick={closeModal}
            disabled={processing}
            classe="btn--outline"
          />
          {transfer ? (
            <Button
              onClick={() => onClick(description, amount)}
              disabled={processing || !amount || !description}
              btnName={processing ? "Processing…" : "Add money"}
              classe="btn--accent"
            />
          ) : isMicrodepositStep ? (
            <Button
              onClick={() => onClick(microAmount1, microAmount2)}
              disabled={processing || !microAmount1 || !microAmount2}
              btnName={processing ? "Processing…" : "Verify deposits"}
              classe="btn--accent"
            />
          ) : verifyBank ? (
            <Button
              onClick={() => onClick(routingNumber, accountNumber)}
              disabled={processing || !routingNumber || !accountNumber}
              btnName={processing ? "Processing…" : "Link bank account"}
              classe="btn--accent"
            />
          ) : withdraw ? (
            <Button
              onClick={() => onClick(description, amount)}
              disabled={processing || !amount || !description}
              btnName={processing ? "Processing…" : "Withdraw"}
              classe="btn--accent"
            />
          ) : (
            <Button
              onClick={() => onClick(description, email, amount)}
              disabled={processing || !amount || !description || !email}
              btnName={processing ? "Processing…" : "Send money"}
              classe="btn--accent"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TransferMoneyModal;
